<template>
  <a-spin :spinning="formOption.busy">
    <a-form :form="form"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 12 }"
    >
      <a-form-item label="名称">
        <a-input placeholder="最多输入6个字" v-decorator="['codeName', rules.name]" :max-length="6"/>
      </a-form-item>
      <a-form-item label="上级分组">
        <a-tree-select
            v-decorator="['parentId']"
            allow-clear
            :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }"
            :treeData="treeData"
            :replaceFields="{children:'children', title:'codeName', key:'codeId', value: 'codeId' }"
        >
        </a-tree-select>
      </a-form-item>
      <a-form-item label="排序">
        <a-input-number :min="1" controls="false" v-decorator="['orderNum', rules.orderNum]" placeholder="请输入分组排序"/>
      </a-form-item>
      <a-form-item label="备注">
        <a-input v-decorator="['remark']" :maxLength="100"/>
      </a-form-item>
    </a-form>
    <a-space class="a-form-btn-box">
      <a-button @click="endEdit('cancelled')">取消</a-button>
      <a-button type="primary" @click="_save(false)">提交</a-button>
    </a-space>

  </a-spin>
</template>

<script>
import {formMixin} from "@/utils/FormMixin";
import XEUtils from "xe-utils";
import {formatter as fmt} from "@/utils/form-formatter";
// 接口API
import {dataApi} from '@/services/operate/ProductBrochure';
console.info(XEUtils)


/**
 * 加载规则
 */
function getRulesTemplate() {
  return {
    name: {
      rules: [{required: true, message: "请输入分类名称"}],
    },
    orderNum: {
      rules: [{required: true, message: "请输入分类排序"}],
    },
  };
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
function afterLoad() {

}

/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {
    parentId: this.parentId,
    codeName: ''
  }
}

/**
 *  加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let entity = await dataApi.getTreeDetail(rowId);
  if (entity.data.parentId === 0) {
    entity.data.parentId = ''
  }
  return fmt.formatFormLoad(entity, [], []);
}

/**
 * 加载基础数据
 */
async function loadBaseData() {
  let menuData = await dataApi.getBrochureTree();
  this.treeData = XEUtils.toArrayTree(menuData.data, {
    key: 'codeId',
    parentKey: 'parentId',
    children: 'children'
  });

}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities, vm) {

  entities.parentId = entities.parentId || 0;
  entities.codeId = vm.rowId || 0;
  entities.isUse = null;
  return await dataApi.saveBrochureTreeDetail(entities);
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  props: ['parentId'],
  watch: {},
  components: {},
  data() {
    return {
      type: 0,
      bussTypeArr: [],
      treeData: [],
      nameLength:0,//分类名称长度

    }
  },

  methods: {
    loadEntity,
    newEntity,
    save,
    getRulesTemplate,
    loadBaseData,
    afterLoad,
    /**
     * 限制分类名称字节 （暂未使用）
     * @param val
     */
    // sizeChange(val){
    //   let value =  val.target.value
    //     let len = 0;
    //     for (let i = 0; i < value.length; i++) {
    //       if (value.charCodeAt(i) > 127 || value.charCodeAt(i) == 94) {
    //         len += 3;
    //       } else {
    //         len++;
    //       }
    //     }
    //   if (len >= 15) this.$message.error ('不能超过5位汉字（15字节）');
    //   this.nameLength =len
    // }
  },
};
</script>

<style scoped lang="stylus">

</style>
